import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Button } from 'semantic-ui-react'
import axios from '../../../api/config/axios'

export const FORM_DOWNLOAD_LINK_TITLES = {
    life: 'Life',
    disability: 'Disability',
    lifeDisability: 'Combined Life/Disability',
    ci: 'Critical Illness/Specified Disease'
}

const FormDownloadLink = ({fileName, formType}) => {
    const handleDownload = async (e) => {
        e.preventDefault()
        try {
            console.log(fileName);
            const response = await axios.get(`/api/forms/render`, {
                params: {fileName},
                responseType: 'blob'
            })

            const blob = new Blob([response.data], {type: 'application/pdf'})
            const url = window.URL.createObjectURL(blob)

            const a = document.createElement('a')
            a.href = url
            a.download = fileName.split('/').pop().replace('.gz', '')
            document.body.appendChild(a)
            a.click()
            a.remove()

            window.URL.revokeObjectURL(url)
        } catch (error) {
            console.error('PDF download failed:', error)
        }
    }

    return (
        <Button
            data-testid='button-link'
            className='Button Button--flat custom-link-btn form-download-link' onClick={handleDownload}>
            <Icon name="file"/>
            <br/>
            {FORM_DOWNLOAD_LINK_TITLES[formType]}
        </Button>
    )
}

FormDownloadLink.propTypes = {
    /** The filename to be downloaded when clicked */
    fileName: PropTypes.string.isRequired,
    /** The type of form, used to display an appropriate pretty title */
    formType: PropTypes.oneOf(Object.keys(FORM_DOWNLOAD_LINK_TITLES)).isRequired
}

export default FormDownloadLink
